interface Props {}

export const Footer: React.FC<Props> = () => (
  <footer>
    <span>스왈라비(주)</span>
  </footer>
);
